import { Dialog as SheetPrimitive } from 'radix-ui'
import { X } from 'lucide-react'
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react'
import { cn } from '@/lib/utils'

/** Side drawer used for detail panels: open, inspect, close — the list keeps its state. */
export const Sheet = SheetPrimitive.Root
export const SheetTrigger = SheetPrimitive.Trigger
export const SheetClose = SheetPrimitive.Close
export const SheetTitle = SheetPrimitive.Title
export const SheetDescription = SheetPrimitive.Description

export const SheetContent = forwardRef<
  ElementRef<typeof SheetPrimitive.Content>,
  ComponentPropsWithoutRef<typeof SheetPrimitive.Content> & { width?: 'md' | 'lg' | 'xl' }
>(({ className, children, width = 'lg', ...props }, ref) => (
  <SheetPrimitive.Portal>
    <SheetPrimitive.Overlay className="fixed inset-0 z-40 bg-overlay/60 animate-fade md:bg-transparent" />
    <SheetPrimitive.Content
      ref={ref}
      className={cn(
        'fixed inset-y-0 right-0 z-50 flex w-full flex-col border-l border-border bg-surface shadow-lg animate-slide-in focus:outline-none md:inset-y-2 md:right-2 md:rounded-xl md:border',
        width === 'md' && 'md:max-w-md',
        width === 'lg' && 'md:max-w-xl',
        width === 'xl' && 'md:max-w-3xl',
        className,
      )}
      {...props}
    >
      {children}
      <SheetPrimitive.Close
        className="absolute top-3 right-3 rounded-md p-1.5 text-fg-subtle transition-colors hover:bg-hover hover:text-fg"
        aria-label="Fechar painel"
      >
        <X className="size-4" />
      </SheetPrimitive.Close>
    </SheetPrimitive.Content>
  </SheetPrimitive.Portal>
))
SheetContent.displayName = 'SheetContent'
